export default "__VITE_ASSET__012cd136__"